import heic2any from 'heic2any';
import loadImage from 'blueimp-load-image';

export async function processImageFile(file) {
  let jpegFile = file;

  // ✅ HEIC → JPEG
  if (file && (file.type === 'image/heic' || file.type === 'image/heif')) {
    const converted = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.95
    });

    const blob = Array.isArray(converted) ? converted[0] : converted;

    jpegFile = new File([blob], (file.name || 'image').replace(/\.(heic|heif)$/i, '.jpg'), {
      type: 'image/jpeg'
    });
  }

  // ✅ Resize + orientation fix
  if (jpegFile && jpegFile.type === 'image/jpeg') {
    jpegFile = await new Promise((resolve) => {
      loadImage(
        jpegFile,
        (img) => {
          if (img instanceof HTMLCanvasElement) {
            const imgWidth = img.width;

            // ✅ CONDITIONAL RESIZE
            let outputCanvas = img;

            if (imgWidth > 2000) {
              // resize already handled by loadImage maxWidth
              outputCanvas = img;
            }

            outputCanvas.toBlob(
              (blob) => {
                if (!blob) {
                  resolve(jpegFile);
                  return;
                }

                resolve(new File([blob], jpegFile.name, { type: 'image/jpeg' }));
              },
              'image/jpeg',
              0.95
            );
          } else {
            resolve(jpegFile);
          }
        },
        {
          meta: true,
          orientation: true,
          canvas: true,
          maxWidth: 2000,
          maxHeight: 2000
        }
      );
    });
  }

  return jpegFile;
}
